import { Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLoginHandlers } from '../handlers/loginHandlers';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const fromState = (location.state as { from?: { pathname: string; search: string } })?.from;
  const searchParams = new URLSearchParams(window.location.search);
  const redirectParam = searchParams.get('redirect');
  const redirectPath = fromState
    ? fromState.pathname + (fromState.search || '')
    : redirectParam || undefined;

  const { onFinish } = getLoginHandlers({ navigate, setLoading, redirectPath });

  return (
    <div style={{ maxWidth: 300, margin: '100px auto' }}>
      <h1>Login</h1>
      <Form onFinish={onFinish}>
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Please enter your username' }]}
        >
          <Input placeholder="Username" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: 'Please enter your password' }]}>
          <Input.Password placeholder="Password" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
